export function getRoundedNumber(value: any, decimalPlaces = 2) {
  return typeof value === 'number' && !Number.isInteger(value)
    ? value.toFixed(decimalPlaces)
    : value
}
